import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { CreateEmployeeRequest } from '@/services/api/petseo.client.wrapper';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { API_ERROR_KEYS, TOAST_MESSAGES, employeeKeys, hasApiErrorCode, toast } from '@petseo/shared';
import { usertourService } from '@/services/usertour.service';

export const useCreateEmployee = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ serviceVendorId, data }: { serviceVendorId: ServiceVendorId; data: CreateEmployeeRequest }) => {
      const response = await serviceVendorsClient.postEmployeeEndpoint(data, serviceVendorId);
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, data }) => {
      queryClient.invalidateQueries({ queryKey: employeeKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.EMPLOYEE_CREATED);
      usertourService.track('employee_added', { ...data });
    },
    onError: (error) => {
      if (hasApiErrorCode(error, API_ERROR_KEYS.SUBSCRIPTION_EMPLOYEE_LIMIT_REACHED)) return;
      toast.error(TOAST_MESSAGES.EMPLOYEE_CREATE_ERROR);
    },
  });

  return {
    ...mutation,
    isEmployeeLimitReached: hasApiErrorCode(mutation.error, API_ERROR_KEYS.SUBSCRIPTION_EMPLOYEE_LIMIT_REACHED),
  };
};
